import { keyMirror } from 'utils/keyMirror';

export const ActionTypes = keyMirror(
  {
    SET_BRAND_DEFINITION: null,
  },
  'BrandDefinition',
);
